import { FC } from 'react'

import { useMutation } from '@tanstack/react-query'
import { Request } from 'commons/utils/request'
import { Toast } from 'ui/components'
import { useConfirmation } from 'ui/hooks'

import { handlerServerError } from '@orbit/errors'

type UseDeleteInvoiceSubmittalConfirmationReturn = {
  DeleteInvoiceSubmittalConfirmation: () => JSX.Element | null
  onShowInvoiceSubmittalConfirmation: (openParams: { id: number }) => void
}

type ConfirmationOpenParams = { id?: number }

const Message: FC<ConfirmationOpenParams> = (props) => (
  <span>
    Are you sure you want to delete invoice submittal <i>IS-{props.id}</i>?
  </span>
)

export const useDeleteInvoiceSubmittalConfirmation = ({
  onSuccess
}: {
  onSuccess: () => void
}): UseDeleteInvoiceSubmittalConfirmationReturn => {
  const { mutate: deleteInvoiceSubmittal } = useMutation<void, Error, { id: number }>({
    mutationFn: ({ id }) => Request.delete(Request.urls.bank.invoiceSubmittal, { id }),
    onSuccess: async () => {
      Toast.successSmall('Invoice Submittal was successfully deleted.')
      onSuccess()
    },
    onError: (error) => handlerServerError(error)
  })

  const { Confirmation: DeleteInvoiceSubmittalConfirmation, open: onShowInvoiceSubmittalConfirmation } =
    useConfirmation<ConfirmationOpenParams>({
      message: <Message />,
      onConfirm: (params) => deleteInvoiceSubmittal({ id: Number(params?.id) }),
      confirmationButtonText: 'Delete',
      isConfirmationNegative: true
    })

  return { DeleteInvoiceSubmittalConfirmation, onShowInvoiceSubmittalConfirmation }
}
